import * as React from "react"
export const CameraIcon = (props) => (
  <svg
    width={25}
    height={25}
    viewBox='0 0 25 25'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M12.5 10.94a2.744 2.744 0 0 0-2.74 2.741c0 1.512 1.229 2.74 2.74 2.74s2.74-1.228 2.74-2.74c0-1.51-1.229-2.74-2.74-2.74'
      fill='#A7A6CE'
    />
    <path
      d='M22.924 5.376h-.776V5.09c0-1.147-.93-2.077-2.077-2.077h-5.495c-1.146 0-2.076.93-2.076 2.077v.286H2.076C.93 5.376 0 6.306 0 7.453V19.91c0 1.146.93 2.076 2.076 2.076h20.848c1.146 0 2.076-.93 2.076-2.076V7.453c0-1.147-.93-2.077-2.076-2.077M3.853 10.941a1.678 1.678 0 1 1 0-3.356 1.678 1.678 0 0 1 0 3.356m8.647 8.837a6.103 6.103 0 0 1-6.096-6.096A6.103 6.103 0 0 1 12.5 7.585a6.103 6.103 0 0 1 6.096 6.097 6.103 6.103 0 0 1-6.096 6.096'
      fill='#A7A6CE'
    />
  </svg>
)
